var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { QuestionnaireFlow } from '../../redux/questionnaire/typings';
import { ModalType } from '../../redux/ui/typings';
import SlideInModal from '../../ui/patterns/SlideinModal';
import { closeModalHelper } from '../../ui/patterns/SlideinModal/helpers/closeHandlers';
import QuestionnaireContent from './subcomponents/QuestionnaireContent';
import QuestionnaireBanner from './subcomponents/QuestionnaireBanner';
var handleEsc = function (event) {
    if (event.key === 'Escape') {
        /**
         * This event method disallows any other `keydown` event within the document from being called
         * Docs: https://developer.mozilla.org/en-US/docs/Web/API/Event/stopImmediatePropagation
         */
        event.stopImmediatePropagation();
    }
};
var Questionnaire = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state; }, shallowEqual), step = _a.questionnaire.step, modalType = _a.ui.modalType;
    var handleCloseQuestionnaire = function () {
        if (step === QuestionnaireFlow.End) {
            return dispatch(closeModalHelper());
        }
        return dispatch(closeModalHelper());
    };
    /**
     * This effect unsets the escape key behavior for SlideInModal.
     * Questionnaire supports input elements that utilize the escape key for keyboard actions, and the modal event listener can interrupt a keyboard user
     */
    useEffect(function () {
        document.addEventListener('keydown', handleEsc);
        return function () {
            document.removeEventListener('keydown', handleEsc);
        };
    }, []);
    return modalType === ModalType.Questionnaire ? (_jsxs(SlideInModal, __assign({ id: "disputes-questionnaire", onCloseModal: handleCloseQuestionnaire }, { children: [_jsx(QuestionnaireBanner, {}), _jsx(QuestionnaireContent, {})] }))) : null;
};
export default Questionnaire;
//# sourceMappingURL=index.js.map